require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./agence-de-voyage-1-1-18-4.json") })
        }
      }, "path---agence-de-voyage-1-1-18-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---agence-de-voyage-1-1-18-4!./.cache/json/agence-de-voyage-1-1-18-4.json
// module id = 322
// module chunks = 231608221292675